window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar, { options: { 'wheelPropagation': true } });

Vue.component('okm-horizontal-scroller', require('./components/HorizontalScroll').default);
// Vue.component('okm-kiyoh-rating', require('./components/KiyohRating').default);
Vue.component('okm-image-slider', require('./components/ImageSlider').default);
Vue.component('okm-horizontal-slot-scroll', require('./components/HorizontalSlotScroll').default);

new Vue({
    'el': '#page',

    comments: true
});